/** Role-role academy panel. */
export const ACADEMY_ROLE = {
  OWNER: 'owner-academy',
  CLUB_MANAGER: 'club-manager-academy',
  ADMIN: 'admin-academy',
} as const

/** Role-role yang boleh mengakses academy panel. */
export const ALLOWED_LOGIN_ROLES = Object.values(ACADEMY_ROLE)
